import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, CanActivate, NavigationEnd } from '@angular/router';
import { ConfigService } from './config.service'
import { MQService } from './mq.service'

export interface OAuthService {
  getAuthorization(): string;
}

@Injectable( {
    providedIn: 'root',
})
export class OAuth2Service implements CanActivate, OAuthService {
    private tokenStorageKey = 'oauth2_token';
    private userStorageKey = 'oauth2_user';
    private token_url = '/oauth/token';
    private refresh_token_url = '/oauth/refresh_token';
    private user_url = '/oauth/user';

    private previousUrl: string;
    private currentUrl: string;

    constructor(private router: Router,
        protected mq: MQService,
        private http: HttpClient,
        private config: ConfigService) {
        this.config.set('oauth2service', this);
        this.currentUrl = this.router.url;
        router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            this.previousUrl = this.currentUrl;
            this.currentUrl = event.url;
          };
        });
    }

    getUrl(path: string) {
        const base_url = this.config.get('base_url');
        return `${base_url}${path}`;
    }

    login(username: string, password: string) {
        this.http.post(this.getUrl(this.token_url), {
                username: username,
                password: password
            }).subscribe(resp => {
                this.handlePassportToken(resp);
            });
    }

    handlePassportToken(data) {
      localStorage.setItem(this.tokenStorageKey, JSON.stringify(data));
      this.fetchAdminInfo();
    }

    fetchAdminInfo() {
      this.http.get(this.getUrl(this.user_url)).subscribe(resp => {
        localStorage.setItem(this.userStorageKey, JSON.stringify(resp));
        if (this.previousUrl === '/login') {
          this.previousUrl = '/dashboard';
        }
        this.mq.notify('user-authed', this.adminInfo());
        this.router.navigate([this.previousUrl]);
      });
    }

    async testAuth() {
      if (this.canActivate()) {
        this.http.get(this.getUrl(this.user_url)).subscribe(resp => {
          this.previousUrl = '/';
          this.router.navigate([this.previousUrl]);
        });
      }
    }

    adminInfo() {
        const user: any = localStorage.getItem(this.userStorageKey);
        if (user) {
            return JSON.parse(user);
        }
        return {};
    }

    checkUserInGroup(groupName) {
        let adminInfo = this.adminInfo();
        let result = false;
        if(Object.keys(adminInfo).length > 0){
            if(adminInfo.hasOwnProperty('groups')){
                adminInfo.groups.forEach(group => {
                    if(group.name == groupName){
                        result = true;
                        return;
                    }
                });
            }
        }
        return result;
    }

    refreshToken() {
        const OAuthToken = this.getOAuthToken();
        if (OAuthToken) {
            this.http.post(this.getUrl(this.refresh_token_url), { refresh_token: OAuthToken.refresh_token }).subscribe(resp => {
                this.mq.notify('user-authed', this.adminInfo());
            })
            return true;
        }
        return false;
    }

    private getOAuthToken() {
        const raw = localStorage.getItem(this.tokenStorageKey);
        if (raw) {
            return JSON.parse(raw);
        }
        return false;
    }

    public getAuthorization(): string {
        const token = this.getOAuthToken();
        if (token) {
            return `${token.token_type} ${token.access_token}`;
        }
        return '';
    }

    canActivate(): boolean {
        if (this.getOAuthToken()) {
            return true;
        }

        this.router.navigate(['/login']);
        return true;
    }
}
